import React, { useState, useEffect } from 'react';
import { zeroPad } from 'react-countdown-now';

const Counter = ({ startDate }) => {
  const [counter, setCounter] = useState(startDate ? Math.floor((Date.now() - startDate) / 1000) : 0);
  let second = zeroPad(counter % 60)
  let minute = zeroPad(Math.floor(counter / 60))

  useEffect(() => {
    const timer =
      counter >= 0 &&
      setTimeout(() => setCounter(counter + 1), 1000);

    return () => {
      clearTimeout(timer)
    }
  }, [counter]);

  return <span>{minute}:{second}</span>;
};

export default Counter;


